// ============================================================================
// munkalistaView.js — a szoba-átfogó munkalista lapja (2026-10-18, v103). Lásd munkalista.js.
// ============================================================================

import { t } from "./i18n.js";
import { el } from "./dom.js";
import { getRoomDisplayName } from "./roomName.js";
import { MUNKALISTA_ALLAPOTOK, munkalistaSorok, sorCim } from "./munkalista.js";


/**
 * @param {HTMLElement} app
 * @param {object} model { uiLang, contentLang, rooms, munkalista: { betolt, hiba, temak, szuro } }
 * @param {object} handlers { onClose, onOpenTopic(roomId, topicId), onFilter(mezo, ertek) }
 */
export function renderMunkalista(app, model, handlers) {
  const { uiLang, contentLang } = model;
  const ml = model.munkalista || { betolt: false, hiba: null, temak: null, szuro: { allapot: "", keszIs: false, csakLejart: false } };
  const backdrop = el("div", { class: "sheet-backdrop open" });
  const sheet = el("div", { class: "sheet tall worklist-sheet", role: "dialog", "aria-label": t(uiLang, "worklist.title") });
  sheet.appendChild(el("div", { class: "sheet-handle" }));
  sheet.appendChild(el("h2", { text: "📋 " + t(uiLang, "worklist.title") }));
  backdrop.addEventListener("click", (e) => { if (e.target === backdrop) handlers.onClose(); });
  backdrop.appendChild(sheet);
  app.appendChild(backdrop);

  // Szűrők
  const szuro = ml.szuro || {};
  const szuroSor = el("div", { class: "worklist-filters" });
  const sel = el("select", { class: "panel-input", "aria-label": t(uiLang, "forum.workflowLabel") });
  sel.appendChild(el("option", { value: "", text: t(uiLang, "worklist.allStatuses") }));
  for (const a of MUNKALISTA_ALLAPOTOK) {
    const o = el("option", { value: a, text: t(uiLang, `forum.wf_${a}`) });
    if (szuro.allapot === a) o.selected = true;
    sel.appendChild(o);
  }
  sel.addEventListener("change", () => handlers.onFilter("allapot", sel.value));
  szuroSor.appendChild(sel);
  const jelolo = (mezo, kulcs) => {
    const cb = el("input", { type: "checkbox" });
    cb.checked = szuro[mezo] === true;
    cb.addEventListener("change", () => handlers.onFilter(mezo, cb.checked));
    return el("label", { class: "tag-check inline" }, [cb, el("span", { text: t(uiLang, kulcs) })]);
  };
  szuroSor.appendChild(jelolo("keszIs", "worklist.showDone"));
  szuroSor.appendChild(jelolo("csakLejart", "worklist.onlyOverdue"));
  sheet.appendChild(szuroSor);

  if (ml.hiba) sheet.appendChild(el("div", { class: "panel-status err", role: "alert", text: ml.hiba }));
  if (!ml.temak) {
    sheet.appendChild(el("p", { class: "hint", text: t(uiLang, ml.betolt ? "worklist.loading" : "worklist.empty") }));
  } else {
    const szobak = model.rooms || [];
    const sorok = munkalistaSorok(szobak, ml.temak, szuro);
    if (sorok.length === 0) {
      sheet.appendChild(el("p", { class: "hint", text: t(uiLang, "worklist.empty") }));
    } else {
      const lista = el("div", { class: "worklist" });
      for (const sor of sorok) {
        const szoba = szobak.find((r) => r.roomId === sor.roomId);
        const szobaNev = szoba ? getRoomDisplayName(szoba, contentLang, uiLang) : "";
        const reszletek = [];
        if (sor.assignee) reszletek.push("👤 " + sor.assignee);
        if (sor.due) reszletek.push("📅 " + sor.due + (sor.lejart ? " · " + t(uiLang, "forum.overdue") : ""));
        lista.appendChild(el("button", {
          type: "button", class: "worklist-row" + (sor.lejart ? " overdue" : ""),
          onclick: () => handlers.onOpenTopic(sor.roomId, sor.topicId),
        }, [
          el("span", { class: "worklist-room", text: szobaNev }),
          el("span", { class: "worklist-title", text: sorCim(sor, contentLang) }),
          el("span", { class: "worklist-meta" }, [
            el("span", { class: `wf-badge wf-${sor.workflow}`, text: t(uiLang, `forum.wf_${sor.workflow}`) }),
            reszletek.length > 0 ? el("span", { class: "wf-owner" + (sor.lejart ? " overdue" : ""), text: reszletek.join(" · ") }) : null,
          ]),
        ]));
      }
      sheet.appendChild(lista);
    }
  }
  sheet.appendChild(el("button", { type: "button", class: "text-btn sheet-close", text: t(uiLang, "admin.close"), onclick: handlers.onClose }));
}
